(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norr-routine-bundle"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-routine-variant]');
  if (!select) return;
  const form = select.closest('[data-norr-routine]');
  const total = Array.from(form.querySelectorAll('[data-routine-variant]')).reduce((sum, input) => sum + Number(input.selectedOptions[0].dataset.price), 0);
  const money = new Intl.NumberFormat(form.dataset.locale, {style: 'currency', currency: form.dataset.currency});
  if (form.querySelector('[data-routine-original]')) form.querySelector('[data-routine-original]').textContent = money.format(total / 100);
  if (form.querySelector('[data-routine-total]')) form.querySelector('[data-routine-total]').textContent = money.format(Math.round(total * .8) / 100);
});
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-norr-routine]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  if (!button || button.disabled) return;
  const error = form.querySelector('[data-routine-error]');
  const items = Array.from(form.querySelectorAll('[data-routine-variant]')).map(select => ({id: Number(select.value), quantity: 1}));
  if (items.length !== 3) return;
  button.disabled = true;
  error.hidden = true;
  try {
    const response = await fetch(form.action + '.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || form.dataset.error);
    const base = form.dataset.cart.slice(0, -4);
    window.location.assign(base + 'discount/NORRROUTINE20?redirect=' + encodeURIComponent(form.dataset.cart));
  } catch (failure) {
    error.textContent = failure.message || form.dataset.error;
    error.hidden = false;
    button.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();
})();
